import { Field, Select } from '@cloudflare/kumo';
import { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuthenticatedFetch } from '../../hooks/useAuthenticatedFetch';

interface Agent { id: string; name: string; active: boolean }

/** Bloco IA: agente (persona, skills e ferramentas). Some quando o plano não tem agentes */
export function AiAgentSelect({ value, onChange }: { value: string; onChange: (id: string) => void }) {
  const fetchApi = useAuthenticatedFetch();
  const [agents, setAgents] = useState<Agent[] | null>(null);
  useEffect(() => {
    fetchApi('/api/ai/agents').then((r) => (r.ok ? r.json() : null)).then((d) => setAgents(d ? d.agents : null)).catch(() => setAgents(null));
  }, [fetchApi]);
  // O Select do Cloudscape recebe a lista por prop `options` (não por filhos)
  // e devolve a opção escolhida em `detail.selectedOption`.
  const options = useMemo(
    () => (agents || []).map((a) => ({ value: a.id, label: `${a.name}${a.active ? '' : ' (pausado)'}` })),
    [agents]
  );
  if (!agents) return null;
  if (!agents.length) {
    return <p className="text-xs text-gray-500">Dica: crie um <Link to="/ia/agentes" className="underline">agente de IA</Link> com skills e use-o aqui.</p>;
  }
  const selectedOption = options.find((o) => o.value === value) ?? null;
  return (
    <div>
      <Field label="Agente de IA (opcional)" description="Com agente, as instruções abaixo viram um complemento para este ponto do fluxo">
        <Select value={(selectedOption)?.value ?? null} items={options} onValueChange={(value: string | null) => onChange(value ?? '')} placeholder="Sem agente: só as instruções do bloco" />
      </Field>
    </div>
  );
}
